import { render } from "./AccountContactRole.vue?vue&type=template&id=0608656f&scoped=true"
import script from "./AccountContactRole.vue?vue&type=script&lang=js"
export * from "./AccountContactRole.vue?vue&type=script&lang=js"

import "./AccountContactRole.vue?vue&type=style&index=0&id=0608656f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0608656f"]])

export default __exports__